import 'bootstrap';
import '@fancyapps/ui';

import './include/init-jquery';
import './include/sliders';
import './include/jquery-code';
import './include/init-maskedinput';
import './include/fancybox';
import './include/catalog-request';
import './include/forms';
import './include/set-city';
import './include/yandex-button';


import CustomHamburger from "./lib/CustomHamburger";
import CustomDropdown from "./lib/CustomDropdown";


new CustomHamburger();
new CustomDropdown();